export default "__VITE_ASSET__DNQkKyw6__"